import React, { Component } from 'react';
import { Button, Label, Input } from 'reactstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


class EditTeamUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            DisableDate: "",
            successMsg: "",
            errors: {},
        };
    }

    componentDidMount() {
        if (this.props.userId) {
            this.setState({ UserDIVATeamID: this.props.userId });
        }
    }


    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };


    handleDateChange = (date) => {
        this.setState({ DisableDate: date });
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { getUserData } = this.props.data;

        if (nextProps.data?.updateUser?.success === true) {
            this.setState({ successMsg: "User updated successfully" });
        }

        if (nextProps.data?.getUserData && nextProps.data.getUserData !== getUserData) {
            const apiData = nextProps.data.getUserData.data;
            const userId = this.state.UserDIVATeamID || this.props.userId;

            const userFromList = nextProps.data.teamData?.find(
                (u) => u.UserDIVATeamID === userId
            );

            if (apiData && apiData.length > 0) {
                this.setState({ ...apiData[0] });
            } else if (userFromList) {
                const matchedType = nextProps.data.accessType?.find(
                    (t) => t.UserTypeName === userFromList.UserTypeName
                );

                this.setState({
                    ...userFromList,
                    UserTypeID: matchedType ? matchedType.UserTypeID : "",
                });
            }
        }
    }



    validate() {
        let firstNameError = "";
        let lastNameError = "";
        let emailError = "";
        let userTypeError = "";

        const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

        if (!this.state.FirstName) firstNameError = "First name is required";
        if (!this.state.LastName) lastNameError = "Last name is required";
        if (!this.state.Email) emailError = "Email is required";
        else if (!mailformat.test(this.state.Email))
            emailError = "You have entered an invalid email";
        if (!this.state.UserTypeID) userTypeError = "Access type is required";

        if (firstNameError || lastNameError || emailError || userTypeError) {
            this.setState({ firstNameError, lastNameError, emailError, userTypeError });
            return false;
        }
        return true;
    }

    handleSaveClick = () => {
        if (this.validate()) {
            const { FirstName, LastName, Email, UserTypeID, DisableDate, UserDIVATeamID } = this.state;

            // Map to Laravel field names
            const payload = {
                user_team_id: UserDIVATeamID,
                first_name: FirstName,
                last_name: LastName,
                email: Email,
                user_type: UserTypeID,
                disable_date: DisableDate || null,
            };

            this.props.onClickhandleUpdateClick(payload);
        }
    };


    render() {
        const { accessType = [], teamUser, getUserData } = this.props.data || {};
        const { errors = {} } = this.state;

        return (
            <div className="card-body">
                <div className="alert alert-info mb-3">
                    Complete the User info below and an invitation will be sent to the User.
                </div>
                <p className="card-text">
                    Add more users to your enterprise account to collaborate.
                </p>

                {this.state.successMsg && (
                    <div id="successMsg" style={{ color: "green" }}>
                        {this.state.successMsg}
                    </div>
                )}

                <div className="user-form-section col-sm-12 col-md-12 col-lg-12 p-0">
                    <div className="form-group row">
                        <input
                            type="hidden"
                            name="UserDIVATeamID"
                            value={this.state.UserDIVATeamID}
                            ref={(input) => {
                                this.actionInput = input;
                            }}
                        />
                        <div className="col-sm-6">
                            <Label>
                                First Name <span className="text-danger">*</span>
                            </Label>
                            <Input
                                type="text"
                                className="form-control"
                                value={this.state.FirstName}
                                id="FirstName"
                                name="FirstName"
                                onChange={this.handleChange}
                            />
                            <p className="text-danger">{this.state.firstNameError}</p>
                            {errors.first_name && (
                                <p className="text-danger">{errors.first_name[0]}</p>
                            )}
                        </div>

                        <div className="col-sm-6">
                            <Label>
                                Last Name <span className="text-danger">*</span>
                            </Label>
                            <Input
                                type="text"
                                className="form-control"
                                value={this.state.LastName}
                                id="LastName"
                                name="LastName"
                                onChange={this.handleChange}
                            />
                            <p className="text-danger">{this.state.lastNameError}</p>
                            {errors.last_name && (
                                <p className="text-danger">{errors.last_name[0]}</p>
                            )}
                        </div>
                    </div>

                    <div className="form-group row">
                        <div className="col-sm-6">
                            <Label>
                                Email <span className="text-danger">*</span>
                            </Label>
                            <Input
                                type="text"
                                className="form-control"
                                value={this.state.Email}
                                id="Email"
                                name="Email"
                                onChange={this.handleChange}
                            />
                            <p className="text-danger">{this.state.emailError}</p>
                            {errors.email && <p className="text-danger">{errors.email[0]}</p>}
                        </div>

                        <div className="col-sm-6">
                            <Label>
                                Access Type <span className="text-danger">*</span>
                            </Label>
                            <Input
                                type="select"
                                value={this.state.UserTypeID}
                                className="form-control"
                                id="UserTypeID"
                                name="UserTypeID"
                                onChange={this.handleChange}
                            >
                                <option value="">--Select access type--</option>
                                {accessType?.length > 0
                                    ? accessType.map((type, index) => (
                                        <option key={index} value={type.UserTypeID}>
                                            {type.UserTypeName}
                                        </option>
                                    ))
                                    : null}
                            </Input>
                            <p className="text-danger">{this.state.userTypeError}</p>
                        </div>
                    </div>

                    <div className="form-group row">
                        <div className="col-sm-6">
                            <Label>Access Disable Date</Label>
                            <div className="input-group mb-2">
                                <div className="input-group-prepend">
                                    <div className="input-group-text">
                                        <i className="far fa-calendar-alt"></i>
                                    </div>
                                </div>
                                <DatePicker
                                    className="form-control"
                                    selected={
                                        this.state.DisableDate
                                            ? new Date(this.state.DisableDate)
                                            : null
                                    }
                                    onChange={this.handleDateChange}
                                    minDate={new Date()}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="form-group row mt-4">
                        <div className="col-12 text-center">
                            <Button
                                color="primary"
                                style={{
                                    backgroundColor: '#083ac8',
                                    border: 'none',
                                    width: '150px',
                                    borderRadius: '5px',
                                    marginRight: '1.5rem',
                                }}
                                onClick={this.handleSaveClick}
                            >
                                Save
                            </Button>

                            <Button
                                color="secondary"
                                style={{
                                    backgroundColor: '#6c757d',
                                    border: 'none',
                                    width: '150px',
                                    borderRadius: '5px',
                                }}
                                onClick={() => this.props.onClose && this.props.onClose()}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default EditTeamUser;
